import { defineStore } from 'pinia';
import { DateTime } from 'luxon';

export interface SyncNotification {
    report_source_id: number;
    name: string;
    consecutive_sync_errors: number;
    last_sync_error_message: string;
    last_sync_error_at: string;
    received_at: DateTime;
}

interface NotificationState {
    syncNotifications: SyncNotification[];
}

export const useNotificationStore = defineStore('notification', {
    state: (): NotificationState => ({
        syncNotifications: [],
    }),
    actions: {
        addSyncNotification(notification: Omit<SyncNotification, 'received_at'>) {
            const index = this.syncNotifications.findIndex((n) => n.report_source_id === notification.report_source_id);
            const newNotification = {
                ...notification,
                received_at: DateTime.now(),
            };

            if (index !== -1) {
                this.syncNotifications.splice(index, 1, newNotification);
            } else {
                this.syncNotifications.push(newNotification);
            }
        },
        removeNotification(reportSourceId: number) {
            this.syncNotifications = this.syncNotifications.filter((n) => n.report_source_id !== reportSourceId);
        },
        clearAll() {
            this.syncNotifications = [];
        },
    },
});
